import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PrivacyPolicy() {
  const [text, setText] = useState("");

  useEffect(() => {
    document.title = "Политика обработки персональных данных — vip77.store";
    api.get("/settings").then((r) => setText(r.data.privacy_policy_text || "")).catch(() => {});
  }, []);

  const paragraphs = text.split(/\n\n+/).filter(Boolean);

  return (
    <div data-testid="privacy-policy-page" className="mx-auto max-w-3xl px-4 py-16 lg:px-8">
      <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Документы</div>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tightest text-ink">Политика обработки персональных данных</h1>
      <div className="mt-8 space-y-4">
        {paragraphs.map((p, i) => {
          const isHeading = /^\d+\.\s/.test(p.trim());
          return isHeading ? (
            <h2 key={i} className="pt-2 text-base font-bold text-ink">{p}</h2>
          ) : (
            <p key={i} className="text-sm leading-relaxed text-muted">{p}</p>
          );
        })}
      </div>
    </div>
  );
}
